import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import colors from 'vuetify/lib/util/colors'

import VDataList from 'usail-vue-sdk/components/VDataList/VDataList'
import VDataListItem from 'usail-vue-sdk/components/VDataList/VDataListItem'
import VDataListLabel from 'usail-vue-sdk/components/VDataList/VDataListLabel'
import VDataListText from 'usail-vue-sdk/components/VDataList/VDataListText'

Vue.use(Vuetify)

Vue.component('v-data-list', VDataList)
Vue.component('v-data-list-item', VDataListItem)
Vue.component('v-data-list-label', VDataListLabel)
Vue.component('v-data-list-text', VDataListText)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.blue.base
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
